import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import OrganisationSidebar from "./OrganisationSidebar";
import "../styles/style.css";

const OrganisationPrivateRoutesSuspense = ({ children }) => {
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);

  return (
    <div>
      <div className="main-wrap">
        <div className={show ? "left-side hide" : "left-side "}>
          <OrganisationSidebar
            isActive={isActive}
            setIsActive={setIsActive}
            show={show}
            setShow={setShow}
          />
        </div>
        <div className="top-fix-sec">
          <Suspense
            fallback={
              <div className="loader-style container-fluid">
                <FadeLoader
                  className="fade-loader"
                  loading={true}
                  color={"#D61F7F"}
                />
              </div>
            }
            >
            <div className={show ? "right-side-cmn hide" : "right-side-cmn "}>
              {children || <Outlet />}
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default OrganisationPrivateRoutesSuspense;
